/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";

const DynamicTestimonials = dynamic(
  () => import("../components/Testimonials/Testimonials"),
  {
    ssr: false,
    loading: () => <Spinner />,
  }
);

export default function TestimonialsPage() {
  const meta = {
    title:
      "Hear it from Qalara’s customers!",
    description:
      "Read what our customers have to say about our service, pricing and process. Here are few testimonials you would like to read.",
    keywords:
      "handmade, fair trade, wholesale buying, global sourcing, Indian crafts, Exporters from India, Verified manufacturers and suppliers, B2B platform",
    url: "/testimonials/",
  };

  return (
    <Layout meta={meta}>
      <>
        <DynamicTestimonials />
      </>
    </Layout>
  );
}
